import { useRouter } from 'vue-router';
import { reactive } from 'vue';
import api from '@/axios/api';
import useUserHooks from '@/hooks/user.hooks';

type valideNames = 'logout' | 'personCenter' | 'notice' | 'tips'

export default () => {
  const userHooks = useUserHooks();
  const icons = ['user', 'bell', 'help', 'exit'];

  const router = useRouter();

  const modalValide = reactive({
    logout: false,
    personCenter: false,
    notice: false,
    tips: false,
  });

  const handleLogoutClick = () => {
    modalValide.logout = true;
  };

  const handleShowModalClick = (modalName: valideNames) => {
    if (modalName === 'personCenter') {
      console.log('this is lofg');
      router.push('/Teacher/userInfo');
    } else {
      modalValide[modalName] = true;
    }
  };

  const handleBackClick = (modalName: valideNames) => {
    modalValide[modalName] = false;
  };

  const handleLogoutCancel = () => {
    modalValide.logout = false;
  };

  const handleLogoutOk = () => {
    userHooks.logout();
    api.logOut();
    handleLogoutCancel();
    router.push('/');
  };

  return {
    icons,
    modalValide,
    handleLogoutClick,
    handleShowModalClick,
    handleBackClick,
    handleLogoutCancel,
    handleLogoutOk,
  };
};
